<template>

    <div class="add-product-container">


        <nav class="add-navigation">
            <div class="buttons-wrapper">
                <strong>Credit: {{balance}}</strong>
                <button class="btn btn-primary" @click="showPaymentModal = true">Add Credit PayPal</button>
                <button class="btn btn-primary addCreditStrype" @click="showPaymentModal1Strip">Add Credit Stripe</button>

                <button class="btn btn-primary addCreditCoin" @click="showPaymentModal2 = true">Add Credit CoinPayments</button>

            </div>
        </nav>
        <Loader :loading="loading" v-if="loading"></Loader>
        <Modal v-if="showPaymentModal" @close="showPaymentModal = null" >
            <h3 slot="header"></h3>
            <div slot="body">
                <form class="form">
                    <div class="row">
                        <div class="col-md-12  col-sm-12">
                            <div class="col-md-12  field-width">
                                <div class="form-group">
                                    <primary-input type="number"
                                                   name="Amount to credit:"
                                                   class="field"
                                                   v-model="paymantAmount"
                                                   v-validate="'required'"
                                                   :class="{'input': true, 'is-danger': errors.has('amount')}"
                                                   placeholder="Amount to credit" />
                                    <div class="help is-danger"
                                         v-if="errors.has('amount')">
                                        {{ errors.first('amount') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12  field-width paypal-image-block">
                                <img src="/img/paypal.png" width="100%" height="100%" alt="">
                            </div>
                            <div class="col-md-12  field-width">
                                <!-- <img src="/img/stripe.png" width="100%" height="100%" alt=""> -->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div slot="footer" class="m-top-100">
                <button class="btn btn-primary submit customBtnStyle" @click="addPayment">Submit</button>
                <button @click="showPaymentModal = null" class="btn btn-default cancel">Cancel</button>
            </div>
        </Modal>
        <Modal v-if="showPaymentModal1" @close="showPaymentModal1 = null" >
            <div slot="closemodal"></div>
            <h3 slot="header"></h3>
            <div slot="body">
                <form>
    <!--                 <form class="form">
                        <div class="row">
                            <div class="col-md-12  col-sm-12">
                                <div class="col-md-12  field-width">
                                    <div class="form-group"> -->
                    <primary-input type="number"
                                   name="Amount to credit:"
                                   class="field"
                                   v-model="paymantAmountStripe"
                                   v-validate="'required'"
                                   :class="{'input': true, 'is-danger': errors.has('amount')}"
                                   placeholder="Amount to credit" />
    <!--                                     <div class="help is-danger"
                                             v-if="errors.has('amount')">
                                            {{ errors.first('amount') }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12  field-width paypal-image-block">
                                </div>
                                <div class="col-md-12  field-width">
                                    <img src="/img/stripe.png" width="100%" height="100%" alt="">
                                </div>
                            </div>
                        </div>
                    </form> -->
                                <!-- A Stripe Element will be inserted here. -->
                            <!-- Used to display Element errors. -->
                   <!--  <form action="/charge" method="post" id="payment-form">
                        <div class="form-row">
                            <label for="card-element">
                                Credit or debit card
                            </label>
                            <div id="card-element">
                            </div>

                            <div id="card-errors" role="alert"></div>
                        </div>

                        <button>Submit Payment</button>
                    </form> -->
                    <!-- <div ref="card" class="mt-4"></div> -->
                    <!-- <button id="checkout-button">Checkout</button> -->
                    <!-- <div id="card-element"></div> -->
                </form>
            <img src="/img/stripe.png" width="100%" height="100%" alt="" class="mt-4">
            </div>
            <div slot="footer" class="m-top-100">
                <!-- <button v-on:click="purchase">Purchase</button> -->
                <button id="checkout-button" class="btn btn-primary submit customBtnStyle" v-on:click="purchase">Submit</button>
                <button @click="showPaymentModal1Close" class="btn btn-default">Cancel</button>
            </div>
        </Modal>

        <Modal v-if="showPaymentModal2" @close="showPaymentModal2 = null" >
            <h3 slot="header"></h3>
            <div slot="body">
                <form class="form">
                    <div class="row">
                        <div class="col-md-12  col-sm-12">
                            <div class="col-md-12  field-width">
                                <div class="form-group">
                                    <primary-input type="number"
                                                   name="Amount to credit:"
                                                   class="field"
                                                   v-model="paymantAmountCoin"
                                                   v-validate="'required'"
                                                   :class="{'input': true, 'is-danger': errors.has('amount')}"
                                                   placeholder="Amount to credit" />
                                        <!-- <button v-on:click="show=!show" type="button">show</button> -->
                                        <coinpayments-button
                                            v-if="show"
                                            :amount="paymantAmountCoin"
                                            :token="token"
                                            :order="order"
                                            :endpoint="endpoint"
                                            v-on:onCreateTransaction="onPayment"
                                            v-on:onError="onError"
                                        />
                                    <div class="help is-danger"
                                         v-if="errors.has('amount')">
                                        {{ errors.first('amount') }}
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12  field-width paypal-image-block">
                                <!-- <img src="/img/paypal.png" width="100%" height="100%" alt=""> -->
                            </div>
                            <div class="col-md-12  field-width">
                                <img src="/img/CoinPayments.png" width="100%" height="100%" alt="">
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div slot="footer" class="m-top-100">
                <button class="btn btn-primary submit customBtnStyle" @click="addPaymentCoin">Submit</button>
                <button @click="showPaymentModal2 = null" class="btn btn-default cancel">Cancel</button>
            </div>
        </Modal>

    </div>
</template>


<script>
//import {stripe} from 'stripe/lib/stripe'
// let stripe = Stripe('pk_live_KFzZbe729TaDlmEqs4bA7nDi00Of1pVtVE')
    // let paymentcomponentscript = document.getElementsByClassName('main-container');
    // console.log(paymentcomponentscript)
    // let stripeScript = document.createElement('script')
    // stripeScript.setAttribute('src', 'https://js.stripe.com/v3/')
    // document.body.insertBefore(paymentcomponentscript[0], stripeScript)

    // eslint-disable-next-line no-undef
    // var stripe = Stripe(`pk_live_KFzZbe729TaDlmEqs4bA7nDi00Of1pVtVE`);
    // let elements = stripe.elements()
    // let card = undefined;

let stripe = Stripe(`pk_live_KFzZbe729TaDlmEqs4bA7nDi00Of1pVtVE`);
// let elements = stripe.elements()
// let card = undefined;



    // let style = {
    //     base: {
    //         border: '5px solid #D8D8D8',
    //         borderRadius: '4px',
    //         color: "#000",
    //     },

    //     invalid: {
    //         color: '#e5424d',
    //         ':focus': {
    //         color: '#303238',
    //         },
    //     },

    // };
    export default {
        // mounted: function () {

                // setTimeout(() => {

                // },500)

    // Create an instance of the card Element.
                // card = elements.create('card');
                // card.mount(this.$refs.card);
            // },500)

// Add an instance of the card Element into the `card-element` <div>.
        // },

        name: "PaymentGateway",
        components: {
            Modal: () => import("@/components/Modal.vue"),
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            CoinpaymentsButton: () => import("@/components/coinpayments-button.vue"),
            Loader: () => import("@/components/Loader.vue"),
        },
        data(){
            return{
                balance: 0,
                user: '',
                paymantAmount: '',
                paymantAmountStripe: '',
                paymantAmountCoin: '',
                loading: false,
                showPaymentModal: null,
                showPaymentModal1: null,
                showPaymentModal2: null,
                token: localStorage['user-token'],
                // amount:
                show: false,
                order: {
                  type: 'PaymentOnly',
                },
                endpoint: process.env.VUE_APP_DEBUG ? 'http://localhost:8008/payments' : undefined
            }
        },
        methods:{
            onPayment(tx, any) {
                console.log('NEW TX:', tx)
            },
            onError(e, Error) {
                console.error(e)
                alert(e.message)
            },
            getBalance() {
                this.user = this.$store.getters.getUser
                this.$store.dispatch('GetBalance', this.user.company_uuid).then((res) => {
                    if(res.data.payload && res.data.payload.total){
                        this.balance = res.data.payload.items[0].balance;
                      console.log(this.balance,"213313213132");
                    }
                });
            },
            addPayment(){
                if (!this.paymantAmount){
                    this.$snotify.error("Amount field required.", {
                        timeout: 3000
                    });
                    return false
                }
                if (this.paymantAmount > this.balance){
                    this.$snotify.error("Your balance is not enough.", {
                        timeout: 3000
                    });
                    return false
                }
                this.loading = true;
                this.showPaymentModal = null
                this.$store.dispatch('AddPaypalPayment', {
                    amount: this.paymantAmount,
                    return_url: window.location.href,
                  // console:console.log(return_url)
                })
                    .then(res => {
                        if (res.approve_link){
                            this.loading = false;
                            window.location.href = res.approve_link
                          console.log( res.approve_link ,"111111111111111")
                        }
                        this.$snotify.success("Payment redirect.", {
                            timeout: 3000

                        });
                })
            },
            addPaymentStrype(){

                // this.loading = true;
                // this.$store.dispatch('AddStripePayment', {
                //     amount: this.paymantAmountStripe,
                //     return_url: window.location.href
                // })
                //     .then(res => {
                //         if (res.approve_link){
                //             this.loading = false;
                //             window.location.href = res.approve_link
                //         }
                //         this.$snotify.success("Payment redirect.", {
                //             timeout: 3000
                //         });
                // })
            },
            showPaymentModal1Strip(){
                this.showPaymentModal1 = true
                // setTimeout(() => {
                    // card = elements.create('card');
                    // card.mount("#card-element");

                // },500)
            },
            showPaymentModal1Close(){
                this.showPaymentModal1 = null
                // card.destroy(this.$refs.card);
            },
            addPaymentCoin(){
                if (!this.paymantAmountCoin){
                    this.$snotify.error("Amount field required.", {
                        timeout: 3000
                    });
                    this.show=false
                    return false
                }
                // if (this.paymantAmountCoin > this.balance){
                //     this.$snotify.error("Your balance is not enough.", {
                //         timeout: 3000
                //     });
                //     this.show=false
                //     return false
                // }
                this.loading = true;
                this.showPaymentModal = null
                this.show=true
            },
            purchase: function () {
                let self = this
                let problem = false;
                const amount=+self.paymantAmountStripe
              console.log(  amount ,"111111111111112")

                // const amount = `{"amount":self.paymantAmountStripe}`
                if (!this.paymantAmountStripe){
                    problem = true
                    this.$snotify.error("Amount field required.", {
                        timeout: 3000
                    });
                }
                // if (this.paymantAmountStripe > this.balance){
                //     problem = true
                //     this.$snotify.error("Your balance is not enough.", {
                //         timeout: 3000
                //     });
                // }
                if(this.paymantAmountStripe < 0.5){
                    problem = true
                    this.$snotify.error("Amount must be at least $0.5 USD.", {
                        timeout: 3000
                    });
                }
                if(!problem){
                    this.$store.dispatch('PaymentStripe',{
                        amount
                    })
                    .then(function(response){
                      console.log(response.data, 'RESPNSE DARA')
                      console.log(stripe.redirectToCheckout({ sessionId : response.data.sessionId }) ,"REDIRECT TO CHECKOUT")
                      return stripe.redirectToCheckout({ sessionId : response.data.sessionId })

                    })
                    .then(function(session){
                        console.log(session, 'SESSION')
                        // this.showPaymentModal1Close()
                        // return stripe.redirectToCheckout({ sessionId : session.id })
                    })
                    .then(function(result){
                            self.$forceUpdate(); // Forcing the DOM to update so the Stripe Element can update.
                            self.$snotify.error(result.error.message, {
                                timeout: 3000
                        })
                    });
                }
            },
        },
        beforeDestroy() {
            // if(card)
            // card.destroy(this.$refs.card);
        },
        created() {
            this.getBalance()
        },
    }
</script>

<style scoped>
    .add-navigation {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 40px;
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        padding: 0 40px;
    }
    .buttons-wrapper strong{
        margin-right: 10px;
    }
    .addCreditStrype{
        margin-left: 10px;
        margin-right: 10px; 
    }
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }
    .paypal-image-block{
        margin-top: 20px;
        margin-bottom: 20px;
    }
</style>